import { richTextFromMarkdown } from '@contentful/rich-text-from-markdown'
import { literal } from 'zod'

export const gatsbyDuplexSectionMockData = {
  __typename: literal('ContentfulDuplex').value,
  contentful_id: 'test-id'
}

async function duplexSectionMock() {
  return {
    __typename: literal('Duplex').value,
    leftCollection: {
      items: [
        {
          __typename: literal('Text').value,
          text: {
            json: await richTextFromMarkdown('example text')
          }
        },
        {
          __typename: literal('Text').value,
          text: {
            json: await richTextFromMarkdown('### This is an H3 heading')
          }
        }
      ]
    },
    rightCollection: {
      items: [
        {
          __typename: literal('ImageLink').value,
          image: {
            url: '/',
            description: 'image example',
            originalWidth: 100,
            originalHeight: 100
          }
        }
      ]
    }
  }
}

export { duplexSectionMock }
